import { useCallback } from 'react';

import { addDays, isBefore } from 'date-fns';

import { useUserGeoQuery } from 'generated/rbi-graphql';
import { useLocale } from 'state/intl';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export const useBlockedByRegion = () => {
  const enableBlockByRegion = useFlag(LaunchDarklyFlag.ENABLE_BLOCK_BY_REGION);
  const { region, setUserCurrentLocale, userCurrentLocale } = useLocale();

  const DAYS_TO_EXPIRE = 1;

  const shouldRefreshCache = (): boolean =>
    !userCurrentLocale || isBefore(new Date(userCurrentLocale.expiration), new Date());

  const { data } = useUserGeoQuery({
    skip: !enableBlockByRegion || !shouldRefreshCache(),
  });

  const isBlockedByRegion = useCallback((): boolean => {
    if (!enableBlockByRegion) {
      return false;
    }

    if (data?.userGeo.country) {
      setUserCurrentLocale({
        country: data.userGeo.country,
        expiration: addDays(new Date(), DAYS_TO_EXPIRE),
      });

      return data.userGeo.country !== region;
    }

    return userCurrentLocale ? userCurrentLocale.country !== region : false;
  }, [data, enableBlockByRegion, region, setUserCurrentLocale, userCurrentLocale]);

  return {
    isBlockedByRegion,
  };
};
